<button
    popover="{{ text | translate }}"
    [placement]="placement"
    triggers="focus"
    style="height: 24px;width: 24px"
>
    <i class="fa fa-{{ icon }}" style="color: #ffffff;padding-top: 4px;">
    </i>
</button>
